<template lang="html">
  <div class="content">
    <h3>Informações para Contato</h3>
    <form @submit.prevent="sendForm(state)">
       <b-field label="Nome">
        <b-input v-model="name"></b-input>
      </b-field>
       <b-field label="CPF">
        <b-input v-mask="['###.###.###-##']" v-model="cpf"></b-input>
      </b-field>
      <b-field label="Telefone">
        <b-input v-mask="['(##) ####-####', '(##) # ####-####']" v-model="phone"></b-input>
      </b-field>
      <b-field label="Email">
        <b-input v-model="email" type="email"></b-input>
      </b-field>
      <button>ENVIAR</button>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'contact',
  data () {
    return {
    }
  },
  beforeMount () {
  },
  computed: {
    ...mapGetters([
      'state',
      'form',
      'contact'
    ]),
    name: {
      get () {
        return this.$store.getters.contact.name
      },
      set (newVal) {
        this.setContactState(['name', newVal])
      }
    },
    cpf: {
      get () {
        return this.$store.getters.contact.cpf
      },
      set (newVal) {
        this.setContactState(['cpf', newVal])
      }
    },
    phone: {
      get () {
        return this.$store.getters.contact.phone
      },
      set (newVal) {
        this.setContactState(['phone', newVal])
      }
    },
    email: {
      get () {
        return this.$store.getters.contact.email
      },
      set (newVal) {
        this.setContactState(['email', newVal])
      }
    }
  },
  mounted () {},
  methods: {
    ...mapActions([
      'setContactState'
    ]),
    sendForm () {
      let form = {
        // licenca_id: this.$store.state.calculatorStore.user.userLicense,
        cod_cidade: this.form.cityCode,
        cod_atividade: this.form.activityCode,
        socios: this.form.partnersQtd,
        funcionarios: this.form.employeesQtd,
        faturameneo: this.form.revenue,
        contato: this.contact.name,
        documento: this.contact.cpf,
        telefone: this.contact.phone,
        email: this.contact.email
      }
      this.$http.post(this.$api('api/contabilidade-online/cadastro'), form).then(response => {
        console.log(response)
        this.$toast.open({
          message: 'Sua solicitação foi enviada com sucesso. Em breve entraremos em contato.',
          type: 'is-success'
        })
        this.$emit('close')
      }, err => {
        this.$toast.open({
          message: err.data.message,
          type: 'is-danger'
        })
        this.$emit('close')
      })
    }
  },
  components: {
  }
}
</script>
